





































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import Footer from "@/views/frame/Footer.vue";
import Header from "@/views/frame/Header.vue";


@Component({
  components: {
    Footer, Header
  },
})
export default class IntelligentWarehousing extends Vue {
  content1Title1: string = '智能仓储-斯诺WMS仓储管理系统'
  content1Title2: string = '仓储软件+智能硬件=高效、便捷'
  content1Title3: string = '仓储软件+智能硬件=高效、便捷，提高业务流程和作业场景的管控力度，提升仓储管理水平和作业效率'
  // content1Title2: string = '软硬件结合，实现生产物料在仓库和车间的全面可视化管理'
  // content1Title3: string = '仓储+标识的创新应用，适用于生产制造企业'
  content2List: any = [
    {
      img: `/static/compress-img/product/warehouse/2/1.png`,
      title: "移动终端作业",
      content: "仓库员工现场作业",
    },
    {
      img: `/static/compress-img/product/warehouse/2/2.png`,
      title: "物资在线管理",
      content: "信息和物流的全面监控",
    },
    {
      img: `/static/compress-img/product/warehouse/2/3.png`,
      title: "物料身份识读",
      content: "扫码绑定物料和身份标识",
    },
    {
      img: `/static/compress-img/product/warehouse/2/4.png`,
      title: "厂内物料监管",
      content: "5G实时高精定位",
    },
  ]
  content3Title: string = '企业仓储管理的痛点'
  content3SubTitle: string = '制造企业存在配件种类繁多、生产装配过程复杂、仓储管理方式落后等现象'
  content3LeftList:any=[
    {title:'实时追踪难',content:'无法实时监控仓库内各个库区在库的货物及位置，无法实时反应物料变化情况'},
    {title:'库内管理难',content:'物料库存时长不准确，缺乏先进先出手段，难以实行准确的采购计划'},
    {title:'人工盘点难',content:'月底盘点非常复杂，而且容易出现盘错的情况，弥补错误往往又耗费不少时间'},
    {title:'库存统计难',content:'无法统计超期物料的在库时长，难以查看库存明细'},
  ]
  content3RightList:any=[
    {title:'配置管理难',content:'无法对单据、单据编码规则、单据打印模板，及物流单位进行管理和维护'},
    {title:'退货处理难',content:'退货作业复杂，耗费人力，无法及时维护各类退料入库'},
    {title:'数据分析难',content:'无法查看仓库内库区库位使用情况，无法进行预警管理'},
    {title:'纸单拣货难',content:'纸单拣货，易出错，基础数据不全，不便于库位整合'},
  ]
  content4Title: string = '密集、自动、透明、智能'
  content4Content1: string = '为企业仓储管理提供信息化、智能化解决方案，适用于制造业仓储、园区仓储等多种业态。通过对动态管理货物、精细管理业务，提升仓储作业效率、管理水平和空间利用率支持集团公司架构，支持多仓库、多货主，多业务模式，可配置的灵活策略和流程增值服务，可实现物动账动，全程 可视化管理，同时附加了数据服务能力。并可以与WCS、ERP等多种软件系统对接，更好地提高企业管理的深度和广度。'
  // content4Content2: string = '通过入库、在库、出库一级规则策略等管理功能，助力客户提升库存管理水平与管理效率，实现降本增效，提质优管的目标，帮助企业实现仓储物资的可视化安全管理和追踪，为物资安置和管理提供直观的决策依据。'
  content5Title: string = '特点与优势'
  content5Index: number = 1
  changeContent5Index(index,status=true){
    this.timer1Runing=status
    this.content5Index = index
  }
  content5List: any = [
    {
      title: '智能化仓储管理',
      content1: '“一单制”数据互联 \n联运各方协同联动',
      content2: '智能硬件产品对接；入库、出库、调拨、盘点、库位等库存管理；报表支持，3D可视化监控管理；数据看板等多样化功能'
    },
    {
      title: '全渠道业务模式',
      content1: '“一单制”数据互联 \n联运各方协同联动',
      content2: '支持动态与自定义盘点、订单与计划补货、越库与调拔等多样业务，根据不同的业务模式提供差异化的行业解决方案'
    },
    {
      title: '多样化业务支持',
      content1: '“一单制”数据互联 \n联运各方协同联动',
      content2: '生产、销售、物流、ERP等供应链业务对接；线上、线下多业务支持；兼容多类型产品、客户的管理需求'
    },
    {
      title: '多项自定义配置',
      content1: '“一单制”数据互联 \n联运各方协同联动',
      content2: '支持属性、单据、规则策略等多项自定义配置；解决不同客户对不同应用场景的数据权限的要求'
    },
    {
      title: '微服务体系架构',
      content1: '“一单制”数据互联 \n联运各方协同联动',
      content2: '基于微服务框架设计, 将单个业务系统拆分为多个可以独立开发、运行和运维的系统'
    },
  ]
  content6Title: string = '硬件产品'
  content6Content: string = '对接智能化设备，软硬件结合，实现仓储流程的整体自动化与智能化集成装卸、存储、包装、运输等环节'
  content6List: any = [
    {
      title: '自动化仓库', list: [
        {
          title: '自动化货柜', img: '/static/compress-img/product/warehouse/3/1.png'
        },
        {
          title: '立体仓', img: '/static/compress-img/product/warehouse/3/2.png'
        },
        {
          title: '堆高车', img: '/static/compress-img/product/warehouse/3/3.png'
        },
        // {
        //   title: '堆垛机', img: '/static/compress-img/product/warehouse/3/3.png'
        // },
      ]
    },
    {
      title: '自动化分拣 ', list: [
        {
          title: '半自动智能分拣器', img: '/static/compress-img/product/warehouse/3/8.png'
        },
        {
          title: '全自动分拣器', img: '/static/compress-img/product/warehouse/3/9.png'
        },
        {
          title: '斜摆轮分拣机', img: '/static/compress-img/product/warehouse/3/10.png'
        },
        // {
        //   title: '定位产品', img: '/static/compress-img/product/warehouse/3/11.png'
        // },
      ]
    },
    {
      title: '自动化搬运', list: [
        {
          title: '输送机', img: '/static/compress-img/product/warehouse/3/4.png'
        },
        {
          title: 'AGV无人搬运车', img: '/static/compress-img/product/warehouse/3/5.png'
        },
        {
          title: '轨道穿梭车', img: '/static/compress-img/product/warehouse/3/6.png'
        },
        {
          title: '自动字母车', img: '/static/compress-img/product/warehouse/3/7.png'
        },
      ]
    },

  ]
  content6RightIndex:number=0
  content6RightList: any = this.content6List[0].list
  changeContent6Data(item,index,status=true){
    // this.timer1Runing=status
    this.content6RightList = item.list
    this.content6RightIndex=index
  }
  timer1:any;
  timer1Runing:boolean=true;
  mounted(){
    this.setTimer()
  }
  beforeDestroy(){
    clearInterval()
  }
  setTimer(){
    this.clearTimer();
    let that=this;
    this.timer1 = setInterval(() => {
      if (!this.timer1Runing){
        return
      }
      if (this.content5Index===4){
        that.content5Index=0;
      }else{
        that.content5Index++;
      }

    }, 3000);
  }
  clearTimer(){
    clearInterval(this.timer1);
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/product/IntelligentWarehousing.vue